import { render } from "./TemplateRight.vue?vue&type=template&id=637a7c73&scoped=true"
import script from "./TemplateRight.vue?vue&type=script&lang=js"
export * from "./TemplateRight.vue?vue&type=script&lang=js"

import "./TemplateRight.vue?vue&type=style&index=0&id=637a7c73&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637a7c73"]])

export default __exports__